'use client';

import React, { memo } from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
  onClick?: () => void;
}

/**
 * The Archlyy mark, inline.
 *
 * The generated app shipped a 324 KB PNG for this; it is a six-path glyph, so
 * it goes in the bundle as SVG instead -- no network request, crisp at any
 * size, and it matches the mark already used in app/static/logo.svg.
 */
const AppLogo = memo(function AppLogo({ size = 28, className = '', onClick }: AppLogoProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Archlyy"
      onClick={onClick}
      className={`${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
    >
      <defs>
        <linearGradient
          id="archlyy-mark-bg"
          x1="8"
          y1="6"
          x2="56"
          y2="58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3b82f6" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="16" fill="url(#archlyy-mark-bg)" />
      <g transform="translate(8 8) scale(2)">
        <path
          d="M12 5 5.4 19.2M12 5 18.6 19.2M8.6 13H15.4"
          stroke="#ffffff"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="5.4" cy="19.2" r="2.4" fill="#ffffff" />
        <circle cx="18.6" cy="19.2" r="2.4" fill="#ffffff" />
        <circle cx="12" cy="5" r="3" fill="#93c5fd" />
      </g>
    </svg>
  );
});

export default AppLogo;
